import { Divider, Flex } from 'antd';
import styles from './personal-info.module.scss';
import { useTranslation } from 'react-i18next';

type PersonalInfoProps = {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
};

export function PersonalInfo({ first_name, last_name, email, phone }: PersonalInfoProps) {
  const { t } = useTranslation('auth');

  return (
    <Flex vertical>
      <Flex vertical gap={5}>
        <p className={styles.personalInfoTitle}>{t('profile.name')}</p>
        <p>{`${first_name} ${last_name}`}</p>
      </Flex>

      <div className={styles.personalInfoDivider}>
        <Divider dashed />
      </div>

      <Flex vertical gap={5}>
        <p className={styles.personalInfoTitle}>{t('fields.email')}</p>
        <p>{email}</p>
      </Flex>

      <div className={styles.personalInfoDivider}>
        <Divider dashed />
      </div>

      <Flex vertical gap={5}>
        <p className={styles.personalInfoTitle}>{t('profile.phone')}</p>
        <p>{phone}</p>
      </Flex>
    </Flex>
  );
}
